/* eslint-disable react/jsx-no-target-blank */
import {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {ILayout, useLayout} from '../../core'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'

const Footer = () => {
  const {config} = useLayout()
  const intl = useIntl()
  useEffect(() => {
    updateDOM(config)
  }, [config])
  return (
    <footer className='site-footer w-100 py-10'>
      <div className='container'>
        {/* Support Card */}
        <div className='support-card mb-20'>
          <div className='support-content'>
            <div className='support-title'>{intl.formatMessage({id: 'FOOTER.SUPPORT_24'})}</div>
            <div className='support-desc'>
              {intl.formatMessage({id: 'FOOTER.SUPPORT_DESC'})}
            </div>
          </div>
          <a href='/contact' className='btn btn-light support-btn'>
            {intl.formatMessage({id: 'FOOTER.REQUEST_CONSULTATION'})}
            <KTIcon iconName='arrow-left' className='ms-2' />
          </a>
        </div>

        {/* Links Grid */}
        <div className='footer-grid'>
          <div className='footer-col'>
            <div className='footer-col-title'>{intl.formatMessage({id: 'FOOTER.SERVICES'})}</div>
            <ul className='footer-links'>
              <li>
                <a href='/mag/'>{intl.formatMessage({id: 'MENU.BLOG'})}</a>
              </li>
            </ul>
          </div>
          <div className='footer-col'>
            <div className='footer-col-title'>{intl.formatMessage({id: 'FOOTER.RESOURCES'})}</div>
            <ul className='footer-links'>
              <li>
                <a href='/about'>{intl.formatMessage({id: 'FOOTER.ABOUT_US'})}</a>
              </li>
              <li>
                <a href='/contact'>{intl.formatMessage({id: 'FOOTER.CONTACT_US'})}</a>
              </li>
              <li>
                <a href='/terms'>{intl.formatMessage({id: 'FOOTER.TERMS'})}</a>
              </li>
              <li>
                <a href='/faq'>{intl.formatMessage({id: 'FOOTER.FAQ'})}</a>
              </li>
            </ul>
          </div>
          <div className='footer-col'>
            <div className='footer-col-title'>{intl.formatMessage({id: 'FOOTER.PARTNERS'})}</div>
            <ul className='footer-links'>
              <li>
                <a href='https://silicone-energy.com/' target='_blank'>
                  {intl.formatMessage({id: 'FOOTER.SILICONE_ENERGY'})}
                </a>
              </li>
              <li>
                <a href='https://bitsobit.com/' target='_blank'>
                  {intl.formatMessage({id: 'FOOTER.BITSOBIT'})}
                </a>
              </li>
            </ul>
          </div>
          <div className='footer-col trust-col'>
            <a
              href='https://semnan.irannsr.org/index.php?module=web_directory&wd_id=107404&ctp_id=1086&id=54028'
              rel='noreferrer nofollow'
              target='_blank'
            >
              <img
                src={toAbsoluteUrl('/media/illustrations/energy/NSR.png')}
                alt='NSR'
                className='trust-badge'
              />
            </a>
          </div>
        </div>

        {/* Social Row */}
        <div className='footer-social'>
          {/* <div className='social-icons'>
						<a href='https://t.me/' target='_blank' aria-label='telegram'><KTIcon iconName='telegram' /></a>
						<a href='https://instagram.com/' target='_blank' aria-label='instagram'><KTIcon iconName='instagram' /></a>
						<a href='https://x.com/' target='_blank' aria-label='twitter'><KTIcon iconName='twitter' /></a>
						<a href='https://linkedin.com/' target='_blank' aria-label='linkedin'><KTIcon iconName='linkedin' /></a>
					</div>
					<div className='brand-mark'>زنجیره‌بلوک انرژی</div> */}
        </div>

        {/* Copyright */}
        <div className='footer-bottom'>
          <span>
            {new Date().getFullYear().toString()} &copy; {intl.formatMessage({id: 'FOOTER.COPYRIGHT'})}
          </span>
        </div>
      </div>
    </footer>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.setAttribute('data-kt-app-footer-fixed', 'true')
  } else {
    document.body.removeAttribute('data-kt-app-footer-fixed')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.setAttribute('data-kt-app-footer-fixed-mobile', 'true')
  } else {
    document.body.removeAttribute('data-kt-app-footer-fixed-mobile')
  }
}

export {Footer}
